/* =================== DEPOIMENTOS =================== */
$(function () {
  const slideItems = $(".carrosel-depoimentos .depoimento-wrp").length;
  const slideDots = slideItems > 1;
  $(".carrosel-depoimentos").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    arrows: false,
    dots: slideDots,
  });
});
